import { Box, Flex } from "@atlaskit/primitives";
import React, { useContext } from "react";
import StyledText from "../../../../primitives/StyledText";
import { DEFAULT_TEXT, DEFAULT_TITLE } from "../../../default";
import { BannerContext } from "../../../context";
import { withStyling } from "../hoc/withStyling";
import AddItemsButton from "../helpers/AddItemsButton";
import { getProp } from "../helpers/getProp";

function UpToDown({ textColor, buttonType }) {
  const { config } = useContext(BannerContext);
  const { title, text } = config;

  return (
    <Box padding="space.500">
      <Flex
        direction="column"
        rowGap="space.200"
        alignItems="center"
        justifyContent="center"
      >
        <StyledText
          customStyles={{
            fontSize: "24px",
            fontWeight: 500,
            lineHeight: "28px",
            color: textColor,
            align: "center",
          }}
        >
          {getProp(title, DEFAULT_TITLE)}
        </StyledText>

        <StyledText align="center" customStyles={{ color: textColor }}>
          {getProp(text, DEFAULT_TEXT)}
        </StyledText>

        <AddItemsButton buttonType={buttonType} />
      </Flex>
    </Box>
  );
}

export default withStyling(UpToDown);
